import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "../commonLanguageHeader";
import { ServicesUrlEndpoints } from "../servicesEndpointConstant";

export interface LookupItem {
  id?: string | number;
  value?: string | number;
  name?: string;
  title?: string;
  label?: string;
  code?: string;
  [key: string]: unknown;
}

export interface LookupResponse {
  response?: LookupItem[];
  data?: LookupItem[];
  [key: string]: unknown;
}

const getLookup = (url: string, params: Record<string, unknown> = {}, language?: string) =>
  ApiService.get<LookupResponse>(url, {
    params,
    ...getLanguageHeaders(language),
  });

export const getLanguageLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.LANGUAGE, params, language);

export const getClientLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.CLIENT, params, language);

export const getClientPresetLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.CLIENT_PRESET, params, language);

export const getClientTypeLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.CLIENT_TYPE, params, language);

export const getClientStatusLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.CLIENT_STATUS, params, language);

export const getCountryLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.COUNTRY, params, language);

export const getReferenceCountries = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.REFERENCE_COUNTRIES, params, language);

export const getTemperatureLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.TEMPERATURE, params, language);

export const getCurrencyLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.CURRENCY, params, language);

export const getWeightLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.WEIGHT, params, language);

export const getVolumeLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.VOLUME, params, language);

export const getFuelLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.FUEL, params, language);

export const getDistanceLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.DISTANCE, params, language);

export const getPositionLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.POSITION, params, language);

export const getProductLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.PRODUCT, params, language);

export const getClientSourceLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.CLIENT_SOURCE, params, language);

export const getClientCompetitorLookup = (
  params: Record<string, unknown> = {},
  language?: string
) => getLookup(ServicesUrlEndpoints.LOOKUP.CLIENT_COMPETITOR, params, language);

export const getClientPositionTypeLookup = (
  params: Record<string, unknown> = {},
  language?: string
) => getLookup(ServicesUrlEndpoints.LOOKUP.CLIENT_POSITION_TYPE, params, language);

export const getPaymentTypeLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.PAYMENT_TYPE, params, language);

export const getPaymentLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.PAYMENT, params, language);

export const getPaymentSubsUnitLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.PAYMENT_SUBS_UNIT, params, language);

export const getPprPaymentTermLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.PPR_PAYMENT_TERM, params, language);

export const getTireMakeLookup = (params: Record<string, unknown> = {}, language?: string) =>
  getLookup(ServicesUrlEndpoints.LOOKUP.TIRE_MAKE, params, language);
